import React, { useContext, useEffect, useState } from "react";
import { RootStoreContext } from "../../mobX/RootStore";
import { observer } from "mobx-react";
import { makeStyles } from "@material-ui/core/styles";
import {
	decodeWidgetURI,
	getFilteredOfferings,
	getSchedulesToDisplay,
	displayTargetGroup,
} from "../../utils/Utils";
import Button from "components/CustomButtons/Button";
import { Link } from "react-router-dom";

const styles = () => ({
	title: {
		margin: 0,
		fontWeight: "500",
	},
	description: {
		margin: 0,
		whiteSpace: "pre-line",
	},
	schedules: {
		margin: 0,
	},
	targetGroup: {
		marginBottom: 5,
	},
	offeringWrapper: {
		marginBottom: 30,
	},
	detailsButton: {
		width: 90,
	},
});

const useStyles = makeStyles(styles);

const Widget = observer(() => {
	const store = useContext(RootStoreContext);
	const clubStore = store.clubStore;
	const [filter, setFilter] = useState({
		targetGroup: {
			from: 0,
			to: 99,
			male: true,
			female: true,
		},
		schedules: [],
		clubID: "",
		category: "",
	});
	const [styles, setStyles] = useState({});

	const [club, setClub] = useState();

	useEffect(() => {
		const uriParams = decodeWidgetURI(window.location.href);
		setFilter({
			targetGroup: uriParams.targetGroup,
			schedules: uriParams.schedules,
			clubID: uriParams.clubID,
			category: uriParams.category,
		});
		setStyles({
			color: uriParams.color,
			fontFamily: uriParams.fontFamily,
		});
		if (uriParams.clubID) {
			clubStore.fetchClub(uriParams.clubID);
		}
	}, []);

	useEffect(() => {
		if (!clubStore.isLoading && filter.clubID) {
			const club = clubStore.getClubById(filter.clubID);
			setClub(club);
		}
	}, [clubStore.isLoading]);

	const classes = useStyles();

	return (
		<div
			style={{
				backgroundColor: "transparent",
				paddingLeft: 10,
				color: styles.color || "black",
				fontFamily: styles.fontFamily || "Fira Sans",
			}}
		>
			{club &&
				club.offerings &&
				getFilteredOfferings(filter, club.offerings).map((offering) => {
					return (
						<div key={offering.id} className={classes.offeringWrapper}>
							<h4
								className={classes.title}
								style={{ fontFamily: styles.fontFamily || "Fira Sans" }}
							>
								{offering.title}
							</h4>
							<p className={classes.schedules}>
								{getSchedulesToDisplay(offering.schedules)}
							</p>
							<p className={classes.targetGroup}>
								{displayTargetGroup(offering.targetGroup)}
							</p>
							<p className={classes.description}>{offering.description}</p>
							<Link
								key={`nextButton-${offering.id}`}
								to={`/offering/${encodeURIComponent(offering.title)}?id=${
									offering.id
								}`}
							>
								<Button color="primary" className={classes.detailsButton}>
									Details
								</Button>
							</Link>
						</div>
					);
				})}
		</div>
	);
});

export default Widget;
